import { api } from '@/services/axios'

interface RegisterClientResponse {
  success: boolean
  message: string
}

export interface RegisterClientBody {
  nome: string
  email: string
  whatsapp: string
  senha: string
}

export async function registerClient(
  data: RegisterClientBody,
): Promise<RegisterClientResponse> {
  try {
    const response = await api.post<RegisterClientResponse>(
      'Usuario/Create',
      data,
    )
    return response.data
  } catch (error: any) {
    if (error.response?.data?.message) {
      throw new Error(error.response.data.message)
    }
    throw new Error('Erro ao realizar cadastro. Tente novamente mais tarde.')
  }
}
